module.exports = function anonymous(locals, escapeFn, include, rethrow
/**/) {
"use strict";
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
        .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
    ; __append("<form class=\"add-bank\"> <p> <a class=\"add_account btn btn-clear btn-block mb-1\" href=\"#\"> <span class=\"fa fa-bank\"></span> Add Bank Account </a> <span>Recommended for reliability and stability purposes. Declined/expired credit cards often prevent purchases.</span> </p> </form> ")
  return __output.join("");

}


//////////////////
// WEBPACK FOOTER
// ./app/components/pages/billing/payment_methods/bank_account_button/template.ejs
// module id = 1136
// module chunks = 1